import { createApi } from "@reduxjs/toolkit/query/react";
import { FilterValue } from "interfaces/FilterTypes";
import { customBaseQuery } from "store/utils";
import {
  CustomBrokerManagerResponse,
  TransactionUploadResponse,
} from "./ImportAPI";

export const adminDetailsApi = createApi({
  reducerPath: "adminDetailsApi",
  baseQuery: customBaseQuery,
  tagTypes: ["AdminDetails", "PartnerDetails"],
  endpoints: (builder) => ({
    getEmployeeList: builder.query<
      TransactionUploadResponse,
      { url: string; params: FilterValue }
    >({
      query: (params) => ({
        url: params.url,
        params: params.params,
      }),
      keepUnusedDataFor: 10,
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map((item) => ({
                type: "AdminDetails" as const,
                id: item.id,
              })),
              { type: "AdminDetails", id: "LIST" },
            ]
          : [{ type: "AdminDetails", id: "LIST" }],
    }),

    getPartner: builder.query<CustomBrokerManagerResponse, FilterValue>({
      query: (params) => ({
        url: "/partner/",
        params,
      }),
      keepUnusedDataFor: 10,
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map((item) => ({
                type: "PartnerDetails" as const,
                id: item.id,
              })),
              { type: "PartnerDetails", id: "LIST" },
            ]
          : [{ type: "PartnerDetails", id: "LIST" }],
    }),
  }),
});

export const { useGetEmployeeListQuery, useGetPartnerQuery } = adminDetailsApi;
